<template>
  <BaseCenteredModal
    v-model:is-modal-open="localIsModalOpen"
    :title="attachmentName"
    size="huge"
  >
    <template #body>
      <div class="flex h-[75vh] w-full">
        <img
          v-if="['image/jpeg', 'image/png', 'image/gif'].includes(mimeType)"
          :src="source"
          :alt="attachmentName"
          class="m-auto max-h-full max-w-full object-contain"
        />
        <iframe
          v-else
          :src="mimeType === 'application/pdf' ? `${source}#toolbar=0` : source"
          class="h-full w-full rounded-md border"
        />
      </div>
    </template>
    <template #footer>
      <BaseButton
        :title="$t('button.print')"
        icon="print"
        color="primary"
        @click="$emit('printFile')"
      />
      <BaseButton :title="$t('button.close')" color="dark" @click="close" />
    </template>
  </BaseCenteredModal>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'

export default {
  name: 'WorkAttachmentShowDialog',
  components: { BaseCenteredModal },
  emits: ['close', 'backdropClicked', 'printFile'],
  props: {
    attachmentIndex: { type: Number, required: true },
    isModalVisible: { type: Boolean, required: true },
    mimeType: { type: String, required: false },
    url: { type: String, required: false }
  },
  data() {
    return {
      docViewer: 'https://view.officeapps.live.com/op/embed.aspx?src='
    }
  },
  computed: {
    ...mapGetters({ work: 'work/getWork' }),
    localIsModalOpen: {
      get() {
        return this.isModalVisible
      },
      set(value) {
        if (!value) this.close()
      }
    },
    attachmentName() {
      return this.work?.attachments?.[this.attachmentIndex]?.name ?? ''
    },
    source() {
      switch (this.mimeType) {
        case 'application/pdf':
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
          return this.url
        default:
          return this.docViewer + this.url
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  },
  watch: {}
}
</script>
